import facePageStyles from '../views/facePageStyles';

const activitySummaryBoxStyles = (theme) => ({
  ...facePageStyles(theme),
  root: {
    margin: '0 0 22px',
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  items: {
    backgroundColor: '#fff',
    display: 'flex',
    flexFlow: 'row nowrap',
  },
  item: {
    backgroundColor: '#fff',
    flex: '1 1 0',
    height: '70px',
    lineHeight: '35px',
    overflow: 'hidden',
    position: 'relative',
    textAlign: 'center',
  },
  interactionCount: {},
  itemNumber: {
    fontSize: '16px',
    marginTop: '8px',
    marginBottom: '-10px',
  },
  itemLabel: {
    fontSize: '12px',
    marginTop: '-10px',
    marginBottom: '8px',
    textOverflow: 'ellipsis',
  },
  lastInteractionDate: {
    borderLeft: '1px solid #e0e0e0',
  },
  inactiveDays: {
    borderLeft: '1px solid #e0e0e0',
  },
});

export default activitySummaryBoxStyles;
